import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Download, X, Monitor } from "lucide-react";
import { getInstallState, subscribeInstall, triggerInstall } from "@/lib/installPrompt";

// Zones du portail : le popup d'installation n'apparaît QUE dans le portail
// (jamais sur le site public), et installe "Mazid Portail" (ouvre /dashboard).
const PORTAL_PREFIXES = ["/dashboard", "/admin-portal", "/connexion", "/login"];

export default function PWAInstallPrompt() {
  const { pathname } = useLocation();
  const [state, setState] = useState(getInstallState());
  const [show, setShow] = useState(false);

  const isPortal = PORTAL_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));

  useEffect(() => subscribeInstall(setState), []);

  useEffect(() => {
    if (!isPortal || !state.canInstall || state.installed) { setShow(false); return; }
    const dismissed = localStorage.getItem("mazid_pwa_dismissed");
    if (dismissed) return;
    const t = setTimeout(() => setShow(true), 8000);
    return () => clearTimeout(t);
  }, [isPortal, state.canInstall, state.installed]);

  const install = async () => {
    await triggerInstall();
    setShow(false);
  };

  const dismiss = () => {
    setShow(false);
    localStorage.setItem("mazid_pwa_dismissed", "1");
  };

  if (!show || state.installed || !state.canInstall) return null;
  const appName = isPortal ? "Mazid Portail" : "Mazid Connect";

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm z-[60] animate-in slide-in-from-bottom" data-testid="pwa-install-prompt">
      <div className="bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden">
        <div className="p-4 flex items-start gap-3">
          <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#1E3A8A] to-[#166534] flex items-center justify-center flex-shrink-0">
            <Monitor className="h-5 w-5 text-white" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-heading font-bold text-sm text-[#0F172A]">Installer {appName}</div>
            <div className="text-xs text-slate-600 mt-0.5">Icône sur votre bureau, fenêtre dédiée — fonctionne même hors-ligne.</div>
            <div className="flex gap-2 mt-3">
              <button onClick={install} className="text-xs px-3 py-1.5 rounded-md bg-[#1E3A8A] text-white font-semibold hover:bg-[#172554] flex items-center gap-1" data-testid="pwa-install-btn">
                <Download className="h-3 w-3" /> Installer
              </button>
              <button onClick={dismiss} className="text-xs px-3 py-1.5 rounded-md bg-slate-100 text-slate-600 hover:bg-slate-200 font-semibold" data-testid="pwa-dismiss-btn">
                Plus tard
              </button>
            </div>
          </div>
          <button onClick={dismiss} className="text-slate-400 hover:text-slate-600 flex-shrink-0" aria-label="Fermer">
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
